import axios from "axios";
import { useState, useEffect } from "react";
import { catalogoObras, propsColeccion } from "../../models/Colecciones.model";
import { webApiContenidoSeccion } from "../../routes/endpoints";
import Elemento from "./elemento";

export default function Contenido(props: propsColeccion) { 
    const [obras, setObras] = useState<catalogoObras[]>([]);
    useEffect(()=>{  
        axios.post(webApiContenidoSeccion, { id:props.id, pagina: props.pagina, limit:props.registrosPorPagina, orden:props.orden, seccion: props.seccion, isAnioAsc: 2  } ).then((response) => {  
            setObras(response.data);                                                                               
        }).catch(err => console.warn(err));          
    },[props.pagina, props.orden ]) 
    const indice = (i:number)=>{ 
        let estilo = ''
        switch (i) {
            case 0:
                estilo = ''
            break;
            case 1:
            case 2:
                estilo = 'mt-3 mt-sm-0'
            break;
            default:
                estilo = 'mt-3 mt-lg-0'
            }
        return estilo
     }
    if(obras?.length){
        return(
            <div className="container-fluid">
                <div className="row justify-content-start justify-content-lg-center text-start">
                {            
                    obras?.map( (obra, i) =>{                        
                      return <Elemento valida_clase={ indice(i)} id={obra.id} imagen={obra.imagen} descripcion={obra.descripcion} anio={obra.anio} key={i}/>                      
                    })
                }
                </div>
            </div> 
        );
    }else{
        return(
        <div className="container-fluid">
            <div className="row justify-content-start justify-content-lg-center text-start text-primary h4">No se encontró información asociada al criterio definido.</div><br/>
        </div>
        )
    }
    
}
